










































import { Component, Vue, Prop } from 'vue-property-decorator'
import { membershipState } from '../../store/modules/MembershipState'
import { DownloadStatus } from '../../modules/class/Downloads'

@Component
export default class RegisterAdditionalModal extends Vue {
  // --------------------------------------------------------------------------------------------------------------------
  // Props
  // PDFのDL-URL. 会員情報追加成功後に利用する
  @Prop() private accessUrl!: string

  // --------------------------------------------------------------------------------------------------------------------
  // data

  // -------------------------------------------------------------------------------------------------------------------
  // getter
  get isRegisterModalAddComplete(): boolean {
    return membershipState.isRegisterModalAddCompleteVisible
  }
  // -------------------------------------------------------------------------------------------------------------------
  // hooks

  // -------------------------------------------------------------------------------------------------------------------
  // methods

  private close() {
    // DL URLをクリア
    membershipState.addAccessUrl('')
    // 0:認証前
    membershipState.addDownloadStatus(DownloadStatus.Unauthorized)
    // この画面を閉じる
    membershipState.addIsRegisterModalAddCompleteVisible(false)
  }

  /**
   * download実行
   */
  private downloadDocument() {
    if (
      membershipState.pdfDownloadAccessUrl !== '' &&
      membershipState.pdfDownloadStatus === DownloadStatus.ReDownloadWait
    ) {
      // 5:再DL待ち→4:再DLトライ→DownloadLinkのwatchdownladstatusへ
      membershipState.addDownloadStatus(DownloadStatus.ReDownloadTry)
    }
    // この画面を閉じる
    membershipState.addIsRegisterModalAddCompleteVisible(false)
  }
}
